export default {
      id: "chevronRight-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#chevronRight-usage",
      toString: function () {
        return this.url;
      }
    }